module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r-container",
    class: {
      'is-loading': _vm.isLoading
    }
  }, [(_vm.isLoading) ? _c('relatorio-loading') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "content-transition relatorio-print",
    attrs: {
      "id": "container-printer"
    }
  }, [_c('div', {
    staticClass: "hidden-print"
  }, [_c('h2', {
    staticClass: "text-center text-uppercase font-bold m-b-none"
  }, [_vm._v("FECHAMENTO DO LEILÃO")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center text-uppercase"
  }, [_vm._v("Leilão Realizado " + _vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))])]), _vm._v(" "), _c('div', {
    staticClass: "printer-page pos-rlt"
  }, [_c('div', {
    staticClass: "visible-print"
  }, [_c('h2', {
    staticClass: "text-center text-uppercase font-bold m-b-none"
  }, [_vm._v("FECHAMENTO DO LEILÃO")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center text-uppercase"
  }, [_vm._v("Leilão Realizado " + _vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))])]), _vm._v(" "), _vm._l((_vm.leilao.fechamentos), function(fechamento, key) {
    return _c('div', {
      key: 'fechamento-' + key,
      staticClass: "r-table"
    }, [(fechamento.comitente) ? _c('div', [_c('div', {
      staticClass: "printer-page"
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
      staticClass: "text-center text-uppercase",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v(_vm._s(fechamento.comitente.pessoa.nome))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "r-table-content"
    }, [_c('table', {
      staticClass: "table table-bordered r-table-min text-center"
    }, [_c('tbody', [_c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Lotes")]), _vm._v(" "), _c('td', [_vm._v("Valor")]), _vm._v(" "), _c('td', [_vm._v("FIPE")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('td', [_vm._v("Qtd")]), _vm._v(" "), _c('td', [_vm._v("%")]), _vm._v(" "), _c('td', [_vm._v("R$")]), _vm._v(" "), _c('td', [_vm._v("%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Total Geral do Leilão")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.total.quantidade))]), _vm._v(" "), _c('td', [_vm._v("100%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.total.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.total.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Retirados")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.retirados.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.retirados.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.retirados.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.retirados.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold text-info"
    }, [_c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v("Abertura do Pregão")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(fechamento.stats.abertura.quantidade))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.abertura.pct)) + "%")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.abertura.valorMinimo)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.abertura.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold text-info",
      staticStyle: {
        "-webkit-print-color-adjust": "exact!important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      attrs: {
        "colspan": "100%"
      }
    }, [_vm._v("Resultado Geral de Vendas")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Recuperáveis")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.recuperaveis.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.recuperaveis.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.recuperaveis.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.recuperaveis.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Vendidos")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.recuperaveis.vendidos.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.recuperaveis.vendidos.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.recuperaveis.vendidos.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.recuperaveis.vendidos.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Não Vendidos")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.recuperaveis.naoVendidos.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.recuperaveis.naoVendidos.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.recuperaveis.naoVendidos.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.recuperaveis.naoVendidos.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold text-info",
      staticStyle: {
        "-webkit-print-color-adjust": "exact!important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Sucatas")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.sucatas.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.sucatas.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.sucatas.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.sucatas.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Vendidos")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.sucatas.vendidos.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.sucatas.vendidos.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.sucatas.vendidos.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.sucatas.vendidos.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Não Vendidos")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.sucatas.naoVendidos.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.sucatas.naoVendidos.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.sucatas.naoVendidos.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.sucatas.naoVendidos.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold text-info",
      staticStyle: {
        "-webkit-print-color-adjust": "exact!important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Condicionais")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.condicionais.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.condicionais.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Recuperáveis Liberadas")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.condicionais.recuperaveisLiberados.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.recuperaveisLiberados.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.recuperaveisLiberados.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.condicionais.recuperaveisLiberados.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Recuperáveis em Análise")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.condicionais.recuperaveisEmAnalise.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.recuperaveisEmAnalise.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.recuperaveisEmAnalise.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.condicionais.recuperaveisEmAnalise.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Sucatas Liberadas")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.condicionais.sucatasLiberados.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.sucatasLiberados.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.sucatasLiberados.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.condicionais.sucatasLiberados.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Sucatas em Análise")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.condicionais.sucatasEmAnalise.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.sucatasEmAnalise.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.sucatasEmAnalise.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.condicionais.sucatasEmAnalise.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Total Liberadas")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.condicionais.liberadas.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.liberadas.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.liberadas.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.condicionais.liberadas.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Total em Análise")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fechamento.stats.condicionais.emAnalise.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.emAnalise.pct)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.condicionais.emAnalise.valorMinimo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.condicionais.emAnalise.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold text-info",
      staticStyle: {
        "-webkit-print-color-adjust": "exact!important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v("Resultado Encerramento")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(fechamento.stats.resultado.encerramento.quantidade))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.resultado.encerramento.pct)) + "%")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.resultado.encerramento.totalVendas)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.resultado.encerramento.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold_"
    }, [_c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#f50900 !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v("Condicionais em Análise")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#f50900 !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(fechamento.stats.resultado.condicionaisEmAnalise.quantidade))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#f50900 !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.resultado.condicionaisEmAnalise.pct)) + "%")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#f50900 !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.resultado.condicionaisEmAnalise.totalVendas)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#f50900 !important",
        "-webkit-print-color-adjust": "exact"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.resultado.condicionaisEmAnalise.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold"
    }, [_c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact",
        "text-decoration": "underline"
      }
    }, [_vm._v("Resultado Esperado")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact",
        "text-decoration": "underline"
      }
    }, [_vm._v(_vm._s(fechamento.stats.resultado.esperado.quantidade))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact",
        "text-decoration": "underline"
      }
    }, [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.resultado.esperado.pct)) + "%")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact",
        "text-decoration": "underline"
      }
    }, [_vm._v(_vm._s(_vm._f("moeda")(fechamento.stats.resultado.esperado.totalVendas)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%",
        "color": "#0c72cb !important",
        "-webkit-print-color-adjust": "exact",
        "text-decoration": "underline"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.resultado.esperado.pctFipe)) + "%")])]), _vm._v(" "), _c('tr', {
      staticClass: "font-bold text-info",
      staticStyle: {
        "-webkit-print-color-adjust": "exact!important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      staticClass: "text-left"
    }, [_c('td', {
      attrs: {
        "colspan": "100%"
      }
    }, [_vm._v("*Média (%) de Venda / FIPE: "), _c('strong', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.resultado.mediaVendaFipe)) + "%")])])]), _vm._v(" "), _c('tr', {
      staticClass: "text-left"
    }, [_c('td', {
      attrs: {
        "colspan": "100%"
      }
    }, [_vm._v("*Média (%) de Veículos Vendidos: "), _c('strong', [_vm._v(_vm._s(_vm._f("number")(fechamento.stats.resultado.mediaVendaQtd)) + "%")])])]), _vm._v(" "), _c('tr', {
      staticClass: "text-left"
    }, [_c('td', {
      attrs: {
        "colspan": "100%"
      }
    }, [_vm._v("*Ticket Médio por Lote R$ " + _vm._s(_vm._f("moeda")(fechamento.stats.resultado.ticketMedioPorLote)))])])])])])])
  })], 2)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1963d4aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/RelatorioFechamento.vue
// module id = 723
// module chunks = 2